import { render, staticRenderFns } from "./redpacket-card.vue?vue&type=template&id=522e30a8&scoped=true"
import script from "./redpacket-card.vue?vue&type=script&lang=js"
export * from "./redpacket-card.vue?vue&type=script&lang=js"
import style0 from "./redpacket-card.vue?vue&type=style&index=0&id=522e30a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522e30a8",
  null
  
)

export default component.exports